export default {
	InWizardMode: 'inWizardMode',
    CurrentWizardStep: 'currentWizardStep',
    EventRetrieved:'eventRetrieved',
    EventId:'eventId'
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Wizard/fields.js